import SearchView from '@app/Search/View'
import SearchCategoryView from '@app/Search/CategoryView'

const KnowledgeSearch = () => import('@app/Search/KnowledgeSearch')

export default function install(Vue) {
  Vue.component(SearchView.name, SearchView)
  Vue.component('KnowledgeSearch', KnowledgeSearch)
  Vue.component(SearchCategoryView.name, SearchCategoryView)
}
